const regCIF = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
const regNIE = /^[XYZ]\d{7,8}[A-Z]$/;
const regNIF = /^(\d{8})([A-Z])$/;
const regMobile = /^(\+)([0-9]){9,20}$/;


export const isRequired = (text) => {
  return text ? "" : "Por favor introduzca todos los campos obligatorios";
};

export const mailValidator = (text, required = false) => {
  if (required && isRequired(text)) return isRequired(text);  
    return /$^|.+@([\w-]+\.)+[\w-]{2,4}$/.test(text) ? "" : "Email no es válido.";
};

export const phoneValidator = (text) => {
  return regMobile.test(text) ?  "" : "Phone is not valid";
};

export const isNumber = (text) => {
  return /^\d+$/.test(text) ? "" : "Must be a number";
};

export const passwordValidator = (text, required = false) => {
  if (required && isRequired(text)) return isRequired(text);
  return /^(?=.*[A-Z])((?=.*\d)(?=.*\W)).{8,50}$/.test(text)
    ? ""
    : "The password must contain between 8 and 50 characters, including an upper case letter, a lower case letter and a number and symbol";
};

export const repeatedPassword = (text, password) => {
  return text === password ? "" : "Password does not match.";
};

export const disabledByCountry = (field, country) => {
  if (country === "MX" && field === "analysisCode2") return false;
  else if (
    country === "CL" &&
    (field === "analysisCode4" || field === "analysisCode5")
  )
    return false;
  else return true;
};

export const lengthValidator = (text, min = 1, max = 999, required = false) => {
  if (required && isRequired(text)) return isRequired(text);
  if (text.length < min || text.length > max)
    return `The value must be between ${min} and ${max} characters in length`;
  return "";
};

export const identValidator = (text, required = false) => {
  if (required && isRequired(text)) return isRequired(text);
  else{
    if(regCIF.test(text) || regNIF.test(text) || regNIE.test(text) ){
      return "";
    }
    else{
      return "Identificator is not valid";
    }
  }

};
